import postTextAgents from "@/components/Settings/Team/PostTextAgents.vue";


let state = {
    postTextAgents: [],
    openAIModels: [],
}

const getters = {
    currentPostTextAgents: state => state.postTextAgents,
    availableOpenAIModels: state => state.openAIModels,
}

const actions = {
    async loadFilteredPostTextAgents({commit, getters})  {
        let response = await window.$app.api.get(`/accounts/${getters.currentAccountOverview.id}/agents`);
        const filteredAgents = response.data.filter(i => i.deleted === false);
        await commit(mutations.SET_POST_TEXT_AGENTS.name, {postTextAgents: filteredAgents})
        return filteredAgents;
    },
    async loadOpenAIModels({commit}) {
        let response = await window.$app.api.get('/openai/models');
        const models = (response.data && response.data.models) || [];
        await commit(mutations.SET_OPENAI_MODELS.name, {openAIModels: models})
        return models;
    },
}

const mutations = {
    SET_POST_TEXT_AGENTS: (state, {postTextAgents}) => {
        state.postTextAgents = postTextAgents;
    },
    SET_OPENAI_MODELS: (state, {openAIModels}) => {
        state.openAIModels = openAIModels;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
